import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  FiSearch, 
  FiBriefcase, 
  FiTrendingUp, 
  FiGlobe, 
  FiBookOpen, 
  FiUsers, 
  FiArrowRight, 
  FiShield, 
  FiFileText, 
  FiSettings, 
  FiArrowLeft, 
  FiCheckCircle 
} from 'react-icons/fi';
import serviceDetails from '../data/serviceDetails';
import ScrollReveal from '../components/ScrollReveal';

const ICONS = {
  FiSearch,
  FiBriefcase,
  FiTrendingUp,
  FiGlobe,
  FiBookOpen,
  FiUsers,
  FiArrowRight,
  FiShield,
  FiFileText,
  FiSettings,
  FiCheckCircle
};

export default function ServiceDetail() {
  const { slug } = useParams();

  // Find service by matching slug property
  const service = Object.values(serviceDetails).find(s => s.slug === slug);

  if (!service) {
    return (
      <div className="page-wrapper">
        <div className="service-detail-not-found">
          <div className="container">
            <ScrollReveal>
              <h2>Service Not Found</h2>
              <p>The service you are looking for does not exist or has been moved.</p>
              <Link to="/services" className="btn-primary">
                <FiArrowLeft /> Back to Services
              </Link>
            </ScrollReveal>
          </div>
        </div>
      </div>
    );
  }

  const IconComponent = ICONS[service.icon] || FiSearch;

  return (
    <div className="page-wrapper">
      {/* Premium Service Hero Section */}
      <div className="service-detail-hero">
        <div className="service-detail-pattern" />
        <div className="service-detail-circle1" />
        <div className="service-detail-circle2" />
        
        <div className="container">
          <ScrollReveal animation="fade-up">
            <div className="service-detail-breadcrumbs">
              <Link to="/">Home</Link>
              <span className="service-detail-separator">/</span>
              <Link to="/services">Services</Link>
              <span className="service-detail-separator">/</span>
              <span className="service-detail-current">{service.title}</span>
            </div>
            
            <div className="service-detail-hero-content">
              <div className="service-detail-icon-wrapper">
                <IconComponent size={32} />
              </div>
              <h1 className="service-detail-title">{service.title}</h1>
              <p className="service-detail-tagline">{service.description}</p>
            </div>
          </ScrollReveal>
        </div>
      </div>

      {/* Main Content Area */}
      <main className="service-detail-main">
        <div className="container">
          <div className="service-detail-content-wrapper">
            {/* Content Blocks */}
            <article className="service-detail-content">
              <ScrollReveal animation="fade-up" delay={100}>
                <div className="service-detail-content-card">
                  {service.blocks && service.blocks.length > 0 ? (
                    service.blocks.map((block, i) => {
                      if (block.type === 'heading') {
                        return (
                          <div key={i} className="service-detail-section-header">
                            <h3 className="service-detail-section-heading">{block.text}</h3>
                            <div className="gold-divider" />
                          </div>
                        );
                      }
                      
                      if (block.type === 'paragraph') {
                        return (
                          <p key={i} className="service-detail-paragraph">
                            {block.text}
                          </p>
                        );
                      }
                      
                      if (block.type === 'list') {
                        return (
                          <ul key={i} className="service-detail-list">
                            {block.items.map((item, idx) => (
                              <li key={idx} className="service-detail-list-item">
                                <FiCheckCircle className="service-detail-check-icon" size={18} />
                                <span className="service-detail-list-text">{item}</span>
                              </li>
                            ))}
                          </ul>
                        );
                      }

                      if (block.type === 'table') {
                        return (
                          <div key={i} className="service-detail-table-wrapper">
                            <table className="service-detail-table">
                              <tbody>
                                {block.rows.map((row, rowIdx) => (
                                  <tr key={rowIdx}>
                                    {row.map((cell, cellIdx) => (
                                      <td key={cellIdx} className={rowIdx === 0 ? 'service-detail-table-header' : 'service-detail-table-cell'}>
                                        {cell}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        );
                      }

                      return null;
                    })
                  ) : (
                    <p className="service-detail-paragraph">
                      Details for {service.title} will be provided shortly. Please contact us for details.
                    </p>
                  )}
                </div>


              </ScrollReveal>
            </article>
          </div>
        </div>
      </main>
    </div>
  );
}
